<div
  class="grid grid-cols-[220px_auto] grid-rows-[74px_1fr] overflow-auto grid-container"
  style="height: calc(100vh - 90px)"
  #layoutContainer>
  <!-- left-top -->
  <div
    class="sticky top-0 left-0 z-30 bg-white border-b border-r border-solid border-c-gb shadow-[5px_0_5px_-2px_rgba(0,0,0,.04)]">
    <ng-content select="[cl-left-top]"></ng-content>
  </div>

  <!-- right-top -->
  <div
    class="sticky top-0 date-cell-row z-20 bg-white border-b border-solid border-c-gb flex flex-row"
    [style.width]="listOfAllDates.length * cellWidth">
    <ng-content select="[cl-right-top]"></ng-content>

    <!-- 加载占位符 - 左 -->
    <div class="pr-2" [style.width]="cursor() * cellWidth">
      <div class="h-[5px] w-full bg-c-gb rounded mt-[34px] animate-pulse"></div>
    </div>
    @for (date of listOfDatesInView(); track date.date) {
      <div
        class="border-l border-solid border-c-gb text-center"
        [ngClass]="{
          '!border-l-[#ced5df]': date.day === 0,
          '!border-l-[#48ca93]': date.isCurrentDay
        }"
        [ngStyle]="{ width: cellWidth }">
        <host-calendar-date-cell
          [date]="date"
          [showMonth]="firstCompleteDateInView() === date.date || date.number === 1"></host-calendar-date-cell>
        <div class="text-[10px] text-c-d2 leading-[24px]">
          <ng-template
            [ngIf]="availableCount"
            [ngTemplateOutlet]="availableCount"
            [ngTemplateOutletContext]="{ date: date.date }"></ng-template>
        </div>
      </div>
    }
    <!-- 加载占位符 - 右 -->
    <div class="flex-1 pl-2">
      <div class="h-[5px] w-full bg-c-gb rounded mt-[34px] animate-pulse"></div>
    </div>
  </div>

  <!-- left-bottom  -->
  <div
    class="sticky left-0 house-cell-col z-20 pb-[80px] border-b border-r border-solid border-c-gb bg-white shadow-[5px_0_5px_-2px_rgba(0,0,0,.04)]">
    <ng-content select="[cl-left-bottom]"></ng-content>
  </div>

  <!-- right-bottom -->
  <div class="calendar-cell-row-col pb-[80px]" [style.width]="listOfAllDates.length * cellWidth">
    <ng-template
      [ngIf]="calendar"
      [ngTemplateOutlet]="calendar"
      [ngTemplateOutletContext]="{ listOfDatesInView: listOfDatesInView(), cursor: cursor() }"></ng-template>
  </div>
</div>
